module.exports = __webpack_public_path__ + "static/media/mybank-homepage.a367880f.jpg";